import axios from 'axios';
import { AuthenticatedApiRepository } from './authenticated_base_repository';
import {
  ALLOWED_MIME_TYPES,
  API_BASE,
  LOCAL_STORAGE_TOKEN_KEY,
} from '../../config/constants';
import { toast } from 'react-toastify';
import { ConfigSelector } from '../../utils/axios/configutation';

export class S3ApiRepository extends AuthenticatedApiRepository {
  store_id: number | undefined;
  base_url: string;
  token = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);

  // Private static instance variable
  private static instance: S3ApiRepository | null = null;

  // Private constructor to prevent external instantiation
  private constructor(axiosInstance: any, store_id?: number) {
    super(axiosInstance);
    this.store_id = store_id;
    this.base_url =
      store_id !== undefined
        ? ConfigSelector.getConfig('/tmp').sellerApiHost
        : ConfigSelector.getConfig('/tmp').managementApiHost;
  }

  // Public static method to get the Singleton instance
  public static getInstance(
    axiosInstance: any,
    store_id?: number,
  ): S3ApiRepository {
    if (!S3ApiRepository.instance) {
      S3ApiRepository.instance = new S3ApiRepository(axiosInstance, store_id);
    }
    return S3ApiRepository.instance;
  }

  addImages = async ({
    images,
    is_public,
  }: {
    images: any;
    is_public: boolean;
  }) => {
    const requests = images?.map((image: any) => {
      return this.getFinalImages({
        image: image,
        is_public: is_public,
      });
    });
    return await Promise.all(requests);
  };

  getFinalImages = async ({
    image,
    is_public,
  }: {
    image: any;
    is_public: boolean;
  }) => {
    const signedData = await this.getSignedUrl({
      image: image,
      is_public: is_public,
    });
    if (signedData.status !== 201 && signedData.status !== 202)
      return Promise.reject(signedData);
    if (signedData.data?.file) {
      const response = await this.uploadImageToSignedUrl({
        signedData: signedData?.data,
        image: image,
      });
      return response;
    }
  };

  getSignedUrl = async ({
    image,
    is_public,
  }: {
    image: any;
    is_public: boolean;
  }) => {
    const generatSignedImageURL =
      this.store_id !== undefined
        ? `${API_BASE}/stores/${this.store_id}/files/get_signed_upload_url/`
        : `${API_BASE}/files/get_signed_upload_url/`;
    const nameWithoutExtension = image.file?.name?.split('.')[0];
    return await axios.post(
      this.base_url + generatSignedImageURL,
      {
        file_extension:
          image.file?.type.split('/')[image.file?.type.split('/').length - 1],
        original_name: nameWithoutExtension,
        is_image: true,
        is_public: is_public,
        alt: image?.file?.alt,
      },
      {
        headers: {
          Authorization: `Bearer ${this.token}`,
          'Content-Type': 'application/json',
        },
      },
    );
  };

  uploadImageToSignedUrl = async ({
    signedData,
    image,
  }: {
    signedData: any;
    image: any;
  }) => {
    try {
      const requestOptions = {
        method: 'PUT',
        headers: {
          'Content-Type': image.file?.type,
        },
        body: image.file,
      };
      await fetch(signedData.presigned_upload_url, requestOptions).catch(
        (error) => {
          console.log(
            'the fetch in uploadImageToSignedUrl in app base says: ',
            error,
          );
        },
      );
      const validateImageURL =
        this.store_id !== undefined
          ? `${API_BASE}/stores/${this.store_id}/files/${signedData.file?.id}/finished_uploading/`
          : `${API_BASE}/files/${signedData.file?.id}/finished_uploading/`;

      const res = await axios.put(
        this.base_url + validateImageURL,
        {},
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
            'Content-Type': 'application/json',
          },
        },
      );
      return { error: false, data: res };
    } catch (e: any) {
      return {
        error: true,
        data: image,
        reason: e.data?.error || e.response?.data.message,
      };
    }
  };

  blobUrlToFile = async (
    blobUrl: string,
  ): Promise<{
    error: boolean;
    file?: File;
  }> => {
    return new Promise((resolve, reject) => {
      fetch(blobUrl)
        .then((res) => {
          res
            .blob()
            .then((blob) => {
              const file = new File([blob], 'from_url.extension', {
                type: blob.type,
              });
              if (ALLOWED_MIME_TYPES.includes(file.type) === false) {
                toast.error('Invalid file type!');
                return;
              }
              resolve({ error: false, file: file });
            })
            .catch(() => {
              toast.error('Something went wrong! maybe url is not correct!');
              reject({ error: true });
            });
        })
        .catch(() => {
          toast.error('Something went wrong! maybe url is not correct!');
          reject({ error: true });
        });
    });
  };
}
